// @ts-expect-error types missing
import { getFormLanguage } from 'FormsUI/selectors/FormDefinition';
import { getFormsLangToAdConsentLang } from 'FormsUI/utils/Lang';
import { fetchAdConsentLabel as fetchAdConsentLabelFromApi } from 'FormsUI/api/AdConsent';
// @ts-expect-error types missing
import { updateFormFieldDefinition } from 'FormsUI/actions/FormDefinition';
import { PRIVACY_ADS_CONSENT_NAME } from 'FormsUI/constants/AdConsent';
import contactObjectTypeId from 'ui-forms-components/constants/objectTypeIds/contactObjectTypeId';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import Log from 'forms-utils-lib/logger/Logger';
const createAction = name => `@@adConsent/${name}`;
export const REQUEST_AD_CONSENT_LABEL = createAction('REQUEST_AD_CONSENT_LABEL');
export const RECEIVE_AD_CONSENT_LABEL = createAction('RECEIVE_AD_CONSENT_LABEL');
export const FAIL_RECEIVING_AD_CONSENT_LABEL = createAction('FAIL_RECEIVING_AD_CONSENT_LABEL');
export const requestAdConsentLabel = () => ({
  type: REQUEST_AD_CONSENT_LABEL
});
export const receiveAdConsentLabel = adConsent => ({
  type: RECEIVE_AD_CONSENT_LABEL,
  adConsent
});
export const failReceivingAdConsentLabel = () => ({
  type: FAIL_RECEIVING_AD_CONSENT_LABEL
});
export const fetchAdConsentLabel = formLang => (dispatch, getState) => {
  const state = getState();
  const formLanguage = formLang || getFormLanguage(state);
  const lang = getFormsLangToAdConsentLang(formLanguage);
  dispatch(requestAdConsentLabel());
  return fetchAdConsentLabelFromApi(lang).then(value => {
    dispatch(receiveAdConsentLabel(value));
    dispatch(updateFormFieldDefinition(PRIVACY_ADS_CONSENT_NAME, contactObjectTypeId, FormFieldKeys.LABEL, value.text));
  }).catch(error => {
    dispatch(failReceivingAdConsentLabel());
    Log.error(`Unable to fetch ad consent`, error);
  });
};